
jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });

});
function toggleText() {
    const content = document.querySelector('.content');
    const button = document.querySelector('.toggle-button');

    if (content.classList.contains('expanded')) {
        content.classList.remove('expanded');
        button.innerHTML = 'Czytaj więcej';
    } else {
        content.classList.add('expanded');
        button.innerHTML = 'Zwiń tekst';
    }
}

document.addEventListener("DOMContentLoaded", function() {
    const content = document.querySelector('.content');
    
    if (content.textContent.length > 100) {
        const button = document.querySelector('.toggle-button');
        button.style.display = 'block';
    }
});

setProducents();
function setProducents(){
  let currentURL = window.location.href;
  let searchText = "products";
  let tableProducent = ["iphone", "samsung", "xiaomi", "huawei", "motorola", "oppo", "realme", "oneplus", "google", "nothing"];
  
  if (currentURL.includes(searchText)) {
    let searchCharIndex = currentURL.lastIndexOf("-");
    let prefixUrl = currentURL.substr(0, searchCharIndex);
    let currentProducent = currentURL.substr(searchCharIndex + 1, currentURL.lastIndexOf("?") - searchCharIndex - 1);
    let boxProducent = document.getElementById("list");

    document.getElementById("boxProducents").innerHTML = "Wybrany producent: " + currentProducent + "<br>";
    // Usuwamy poprzednią opcję -Wybierz-, aby dodać zaktualizowaną
    boxProducent.innerHTML = `<option value=''>${currentProducent}</option>`;
    for (let e of tableProducent) {
      let searchLink = prefixUrl + "-" + e;
      fetch(searchLink)
        .then(response => {
          if (response.ok) {
            boxProducent.innerHTML += `<option value='${searchLink}'>${e}</option>`;
          }
        })
        .catch(error => {
          console.error('Wystąpił błąd podczas sprawdzania linku:', error);
        });
    }
  }
}

// Pobierz element listy rozwijalnej
var lista = document.getElementById("list");

// Dodaj nasłuchiwanie zdarzenia change
lista.addEventListener("change", function() {
    var wybranaOpcja = lista.value;
    if (wybranaOpcja) {
        window.location.href = wybranaOpcja;
    }
});


/* Menu do BreadCrumps w kolekcjach */
function toggleNav() {
    var sidenav = document.getElementById("shopifySideNav");
    if (sidenav.style.width === '250px') {
        sidenav.style.width = '0';
    } else {
        sidenav.style.width = '250px';
    }
}

function toggleDropdown(dropdownContent) {
    if (dropdownContent.style.display === 'block') {
        dropdownContent.style.display = 'none';
    } else {
        dropdownContent.style.display = 'block';
    }
}

function updateButtonText(text) {
    var button = document.getElementById("shopify-side-menu-button");
    button.textContent = text;
}

document.addEventListener('DOMContentLoaded', function() {
    // Możliwe dodatkowe inicjalizacje
});


//Przycisk do filtrowania w breadcramps
//function applyFilter(filterLabel, filterHandle) {
    // Przygotowanie URL do aktualizacji
    //var baseUrl = window.location.pathname;
    //var searchParams = new URLSearchParams(window.location.search);

    // Dodanie lub aktualizacja parametru 'constraint'
   // searchParams.set('constraint', filterHandle);

    // Konstruowanie pełnego URL z aktualizacjami
    //var newUrl = baseUrl + '?' + searchParams.toString();
    //window.location.href = newUrl;
//}
function toggleFilters() {
    var content = document.querySelector('.t4s-facet-content');
    if (content.style.display === "none") {
        content.style.display = "block";
    } else {
        content.style.display = "none";
    }
  
}

document.getElementById('filterButton').addEventListener('click', function() {
    var dropdown = document.getElementById('filterDropdown');
    dropdown.style.display = dropdown.style.display === 'none' ? 'block' : 'none';
});

// Dodaj obsługę kliknięcia poza element, aby zamknąć dropdown
window.onclick = function(event) {
    if (!event.target.matches('.filter-toggle-button')) {
        var dropdowns = document.getElementsByClassName("filter-dropdown-content");
        for (var i = 0; i < dropdowns.length; i++) {
            var openDropdown = dropdowns[i];
            if (openDropdown.style.display === "block") {
                openDropdown.style.display = "none";
            }
        }
    }
}
function applyFilter(url) {
    if (url) {
        window.location.href = url; // Przekierowanie na wybrany URL
    }
}
function updateLabelAndFilter() {
    var select = document.getElementById('filterSelect');
    var selectedOption = select.options[select.selectedIndex];
    var label = document.getElementById('selectedFilterLabel');



     //Przekierowanie, jeśli wybrano konkretny rodzaj etui
   if (selectedOption.value) {
    window.location.href = selectedOption.value;
    }
}


//new

document.addEventListener('DOMContentLoaded', function() {
    var select = document.getElementById('filterSelect');
    var currentFilter = new URLSearchParams(window.location.search).get('filter.p.m.custom.rodzaj_etui');

    if (currentFilter) {
        for (var i = 0; i < select.options.length; i++) {
            if (select.options[i].value === currentFilter) {
                select.selectedIndex = i;
                updateLabelAndFilter();  // Uaktualnij etykietę na podstawie wybranej opcji
                break;
            }
        }
    }
});

document.addEventListener('DOMContentLoaded', function() {
    const params = new URLSearchParams(window.location.search);
    const filter = params.get('filter.p.m.custom.rodzaj_etui');
    if (filter) {
        const option = document.querySelector(`option[value='?filter.p.m.custom.rodzaj_etui=${filter}']`);
        if (option) {
            option.selected = true;
            updateLabel(option.textContent);
        }
    }
});

document.addEventListener('DOMContentLoaded', function() {
    displayCurrentFilters();
});

function displayCurrentFilters() {
    const filterElements = document.querySelectorAll('.t4s-active-filters__remove-filter');
    const filterTexts = Array.from(filterElements).map(elem => elem.textContent.trim()).join(', ');
    document.getElementById('currentFiltersDisplay').textContent = filterTexts;

    // Możesz również automatycznie aktualizować tekst przy zmianie filtrów, jeśli są dynamicznie dodawane lub usuwane
    // Można dodać obserwatora DOM lub inny mechanizm reagujący na zmiany
}

function updateLabelAndFilter() {
    var select = document.getElementById('filterSelect');
    var selectedOption = select.options[select.selectedIndex];
    var label = document.getElementById('selectedFilterLabel');

    label.textContent = 'Wybierz rodzaj etui: ' + (selectedOption.text === 'Wybierz rodzaj etui' ? '' : selectedOption.text);

    if (selectedOption.value) {
        window.location.href = selectedOption.value;
    }
}


